import axios from "axios";

const api = axios.create({
  baseURL: "https://api.doramahype.ru/api/v1",
  withCredentials: true,
});

// Материалы (дорамы)
export const materialsAPI = {
  getAll: (params) =>
    api.get("/materials", {
      params: {
        search: params?.search,
        type: params?.type,
        genre: params?.genre,
        country: params?.country,
        year: params?.year,
        sort_by: params?.sort_by,
        sort_order: params?.sort_order,
        page: params?.page,
        per_page: params?.per_page,
      },
    }),

  getById: (id) =>
    api.get(`/materials/${id}`),

  getBySlug: (slug, slug_id) =>
    api.get(`/materials/slug/${slug}/${slug_id}`),
};

// Группы
export const groupsAPI = {
  getAll: () =>
    api.get("/groups"),

  getById: (id) =>
    api.get(`/groups/${id}`),
};

// Команды
export const teamsAPI = {
  getAll: () =>
    api.get("/teams"),

  getById: (id) =>
    api.get(`/teams/${id}`),
};

// Переводы
export const translationsAPI = {
  getByMaterial: (material_id) =>
    api.get(`/translations/material/${material_id}`),
};

export default api;
